import { service } from '@ember/service';
import type AnnouncementTemplateModel from 'garaje/models/announcement-template';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type { SinglePayload } from 'jsonapi/response';

import ApplicationSerializer from './application';

export default class AnnouncementTemplateSerializer extends ApplicationSerializer {
  @service declare featureFlags: FeatureFlagsService;

  attrs = {
    createdAt: {
      serialize: false,
    },
    updatedAt: {
      serialize: false,
    },
  };

  serialize(...args: Parameters<ApplicationSerializer['serialize']>): SinglePayload<AnnouncementTemplateModel> {
    const payload = <SinglePayload<AnnouncementTemplateModel>>super.serialize(...args);
    const defaultEmployeeGroups = payload?.data?.attributes['default-employee-groups'];
    const defaultEmployees = payload?.data?.attributes['default-employees'];
    const defaultAnnouncementResponseOptions = payload?.data?.attributes['default-announcement-response-options'];

    if (defaultAnnouncementResponseOptions?.length) {
      delete payload.data.attributes['default-announcement-response-options'];

      payload.data.relationships['announcement-response-options'] = {
        data: defaultAnnouncementResponseOptions.map((option: { label: string; category: string }) => ({
          type: 'announcement-response-options',
          attributes: {
            label: option.label,
            category: option.category,
          },
        })),
      };
    }

    if (defaultEmployeeGroups?.length) {
      delete payload.data.attributes['default-employee-groups'];

      payload.data.relationships['employee-groups'] = {
        data: defaultEmployeeGroups.map((id) => ({
          id,
          type: 'employee-groups',
        })),
      };
    }

    if (defaultEmployees?.length) {
      delete payload.data.attributes['default-employees'];

      payload.data.relationships['employees'] = {
        data: defaultEmployees.map((id) => ({
          id,
          type: 'employees',
        })),
      };
    }

    return payload;
  }
}
